// 方法
import { accAdd, getThumbUrl } from '../utils/dataUtils';
// 常量
import { STATUS_CREATED, STATUS_CREATED_CODE } from '../constants/constant';
import { NamePath } from '../constants/interface';
import { ITotalItem } from '../SuperTable/subpage/tableTotal';

export function dataToUploads(initialValue: any, relativePath: any) {
  if (!initialValue) return initialValue;
  const result = [];
  if (typeof initialValue === 'string') {
    result.push({
      uid: '-1',
      status: 'done',
      url: initialValue,
      thumbUrl: getThumbUrl(initialValue),
      relativePath: relativePath,
    });
  }
  if (Array.isArray(initialValue)) {
    initialValue.forEach((v, i) => {
      result.push({
        uid: i,
        status: 'done',
        url: v,
        thumbUrl: getThumbUrl(v),
        relativePath: relativePath[i],
      });
    });
  }
  return result;
}

export function dataToUpload(initialValue: any, relativePath: any) {
  if (!initialValue) return initialValue;
  if (typeof initialValue === 'string') {
    return [
      {
        uid: '-1',
        status: 'done',
        url: initialValue,
        thumbUrl: getThumbUrl(initialValue),
        relativePath: relativePath,
      },
    ];
  }
  return initialValue;
}

export function getRecordCode(recordCode: number, formCode: number) {
  if (recordCode === STATUS_CREATED.ADD || recordCode === STATUS_CREATED.DELETE)
    return recordCode;
  return formCode || recordCode;
}

export function formatDataSource(
  dataSource: any[],
): { effectiveData: any[]; deleteData: any[] } {
  const effectiveData: any[] = [];
  const deleteData: any[] = [];
  dataSource.forEach(item => {
    if (item[STATUS_CREATED_CODE] === STATUS_CREATED.DELETE) {
      delete item.key;
      delete item.HISTORY_LIST_DATA;
      delete item.sortIndex;
      deleteData.push(item);
    } else {
      effectiveData.push(item);
    }
  });
  return { effectiveData, deleteData };
}

export function getUpdateStatus(status: any) {
  return status === STATUS_CREATED.ADD
    ? STATUS_CREATED.ADD
    : STATUS_CREATED.UPDATE;
}

export function filterDataSource(
  dataSource?: any[],
  mergeRowKey?: string,
): any[] {
  if (!dataSource) return [];
  const effectiveDataSource = dataSource.filter(
    v => v[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE,
  );
  if (effectiveDataSource.length && mergeRowKey) {
    const sortObj: any = {};
    const sortDataSource: any[] = [];
    effectiveDataSource.forEach(v => {
      const mergeValue: string = v[mergeRowKey];
      if (!sortObj[mergeValue]) {
        sortObj[mergeValue] = [v];
      } else {
        sortObj[mergeValue].push(v);
      }
    });
    for (let [key, value] of Object.entries(sortObj)) {
      if (Array.isArray(value))
        sortDataSource.push({
          [mergeRowKey]: key,
          key: key,
          isMainTable: true,
          children: value,
        });
    }
    return sortDataSource;
  }
  return effectiveDataSource;
}
export function getTotalInfo(
  totalKeys?: ITotalItem[],
  dataSource?: any[],
): any {
  let totalData: any = {};
  if (Array.isArray(totalKeys) && Array.isArray(dataSource)) {
    totalKeys.forEach(item => {
      const { dataIndex, format } = item;
      const currentValue = dataIndexTotal(dataIndex, dataSource);
      // totalData.push({
      //   label: title,
      //   value: format ? format(currentValue) : currentValue,
      //   key: key || dataIndex,
      // });
      totalData[dataIndex] = format ? format(currentValue) : currentValue;
    });
  }
  return totalData;
}

export function dataIndexTotal(dataIndex: string, dataSource: any[]): number {
  let total: number = 0;
  dataSource.forEach(item => {
    if (item[dataIndex]) total = accAdd(total, Number(item[dataIndex]) || 0);
  });
  return total;
}
/**
 * 获取默认值
 * @param initialValue 默认值
 * @param record 当前行数据
 * @param name 列字段名
 * @returns 
 */
export function getInitialValue(initialValue: any, record: any, name?: NamePath) {
  const labelKey = Array.isArray(name) ? name[0] : name;
  if (labelKey && record?.[labelKey] !== undefined) return record[labelKey];
  if (initialValue !== undefined) return initialValue;
  return undefined;
}
